var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMusicNote = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.39258 2.66451V0.461386C7.39258 0.150839 7.14062 -0.0483801 6.8418 0.0102137L3.83008 0.666464C3.45508 0.748495 3.25 0.953573 3.25 1.2817L3.26172 7.79732C3.29102 8.08443 3.15625 8.27193 2.89844 8.32467L1.9668 8.51803C0.794922 8.76412 0.244141 9.36178 0.244141 10.2465C0.244141 11.143 0.935547 11.77 1.9082 11.77C2.76953 11.77 4.05859 11.1372 4.05859 9.43209V4.07076C4.05859 3.76021 4.11719 3.69576 4.39258 3.63717L7.07031 3.05123C7.26953 3.01021 7.39258 2.85787 7.39258 2.66451Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMusicNote);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-music-note.2f3f8f4bdea65a6bbcdd11f1ad1b4b31.svg";